module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/th/1-50ab1d24e5d5eca1691bb7b4371c8722.jpg";